// Guida ai segnaposto dei modelli della pagina di prenotazione.
// Scritta per essere data a Claude (o a un grafico) insieme al modello di esempio: elenca
// esattamente i segnaposto e le regole che il backend controlla al caricamento.
// Se il backend cambia le regole, vanno aggiornati anche questi elenchi.

export interface VoceGuida { codice: string; significato: string }

export const SEGNAPOSTO_TESTO: VoceGuida[] = [
  { codice: '{{cantiere.nome}}', significato: 'Nome del cantiere' },
  { codice: '{{cantiere.indirizzo}}', significato: 'Indirizzo del cantiere' },
  { codice: '{{cantiere.impresa}}', significato: "Nome dell'impresa costruttrice" },
  { codice: '{{cantiere.scadenza_scelte}}', significato: 'Data entro cui completare le scelte, nel formato gg/mm/aaaa (vuoto se non impostata)' },
  { codice: '{{cantiere.testo_benvenuto}}', significato: 'Testo di benvenuto del cantiere (vuoto se non impostato)' },
  { codice: '{{cantiere.brochure}}', significato: 'Indirizzo web (URL) della brochure del capitolato, oppure vuoto se non c\'è' },
  { codice: '{{cantiere.copertina}}', significato: 'Indirizzo web (URL) dell\'immagine di copertina del cantiere, oppure vuoto' },
  { codice: '{{impresa.logo}}', significato: 'Indirizzo web (URL) del logo dell\'impresa, oppure vuoto' },
  { codice: '{{negozio.nome}}', significato: 'Nome del negozio dove si svolge l\'incontro' },
  { codice: '{{negozio.indirizzo}}', significato: 'Indirizzo del negozio' },
  { codice: '{{negozio.telefono}}', significato: 'Telefono del negozio' },
  { codice: '{{negozio.email}}', significato: 'Email di contatto del negozio' },
  { codice: '{{negozio.logo}}', significato: 'Indirizzo web (URL) del logo del negozio, oppure vuoto' },
  { codice: '{{buono.atrio}}', significato: 'Condizioni del buono Atrio (consulenza gratuita), come scritte nella configurazione del percorso' },
  { codice: '{{buono.aran}}', significato: 'Condizioni del buono Aran (sconto sulla cucina), come scritte nella configurazione del percorso' },
  { codice: '{{acquirente.nome}}', significato: 'Nome dell\'acquirente: compilato solo sul link personale, vuoto sulla pagina del cantiere' },
  { codice: '{{venditore.nome}}', significato: 'Nome del venditore che aspetta l\'acquirente: compilato solo sul link personale, vuoto altrove' },
  { codice: '{{primo_incontro}}', significato: 'Vale "si" sulla pagina del cantiere (prenotazione del primo incontro), vuoto sul link personale. Si usa solo in {{#se primo_incontro}} … {{/se}}' },
  { codice: '{{link_personale}}', significato: 'Vale "si" sul link personale dell\'acquirente (incontri successivi), vuoto sulla pagina del cantiere. Si usa solo in {{#se link_personale}} … {{/se}}' },
];

export const REGOLE_PRENOTAZIONE: string[] = [
  'Il segnaposto {{prenotazione}} deve comparire esattamente una volta nel file HTML: è il punto in cui BOP inserisce la scelta di giorno e ora, il modulo con i dati, il consenso, la conferma e i contatti.',
  'Non disegnare né simulare il blocco di prenotazione: lo fornisce BOP, con il suo stile. Il modello disegna solo il resto della pagina (intestazione, copertina, testi, immagini, piè di pagina).',
  '{{prenotazione}} va scritto da solo, come contenuto di un elemento: non dentro un blocco {{#se}}, non dentro il valore di un attributo (per esempio title="{{prenotazione}}") e non dentro un link <a>.',
  'Se {{prenotazione}} manca, è ripetuto o è in una di queste posizioni, il modello viene rifiutato.',
];

export const REGOLE_CONDIZIONALE: string[] = [
  'L\'unico blocco ammesso è {{#se <segnaposto>}} … {{/se}}: il contenuto compare solo se il valore del segnaposto non è vuoto.',
  'Usalo per tutto ciò che può mancare: logo dell\'impresa, copertina, brochure, testo di benvenuto, scadenza, telefono, email, buoni.',
  'Esempio: {{#se impresa.logo}}<img src="{{impresa.logo}}" alt="Logo dell\'impresa">{{/se}}',
  'La stessa pagina HTML serve due pagine diverse: quella del cantiere (primo incontro) e il link personale dell\'acquirente (incontri successivi). Per mostrare testi diversi usa {{#se primo_incontro}} … {{/se}} e {{#se link_personale}} … {{/se}}.',
  'Esempio: {{#se primo_incontro}}<h1>Prenota il tuo primo incontro</h1>{{/se}}{{#se link_personale}}<h1>Ciao {{acquirente.nome}}, prenota il prossimo incontro</h1>{{/se}}',
  'Esempio per il venditore, che sul link personale può mancare: {{#se venditore.nome}}<p>Ti aspetta {{venditore.nome}}.</p>{{/se}}',
  '{{else}} e {{^se}} non esistono (vengono rifiutati): per il caso contrario scrivi un secondo blocco {{#se}} con l\'altro segnaposto.',
  'Non esistono altri blocchi, helper, partial o cicli: {{#each}}, {{#if}}, {{> parziale}} e simili sono rifiutati.',
];

export const REGOLE_TESTO: string[] = [
  'Si possono usare solo i segnaposto elencati sopra e {{prenotazione}}: un segnaposto sconosciuto fa rifiutare il modello.',
  'I segnaposto di testo sono sempre scritti con le doppie graffe {{ }}, che rendono innocuo il contenuto. Le triple graffe {{{ }}} sono vietate.',
  'I valori possono essere vuoti: prevedi sempre cosa succede se un testo manca (usa {{#se}}).',
];

export const REGOLE_IMMAGINI: string[] = [
  'Le immagini del modello si caricano insieme ai file e si citano come immagini/<nomefile>, per esempio <img src="immagini/sfondo.jpg" alt="">. Nel CSS: url(immagini/sfondo.jpg).',
  'Ogni immagine citata deve essere stata caricata (altrimenti il modello viene rifiutato). Formati: jpg, png, webp, svg. Al massimo 2 MB ciascuna e 30 per modello.',
  'I nomi file sono scritti in minuscolo e possono contenere solo lettere, numeri, punto, trattino e trattino basso (a-z, 0-9, ., _, -).',
  'Nell\'HTML, src e srcset (img e source) accettano solo immagini/<nomefile> oppure i segnaposto {{impresa.logo}}, {{cantiere.copertina}}, {{negozio.logo}}. Nessun indirizzo esterno.',
  'Nel CSS url(...) accetta solo immagini/<nomefile> oppure data:image/... (immagini incorporate). Nessun indirizzo esterno.',
];

export const REGOLE_COLORI: string[] = [
  'I colori scelti per il cantiere NON sono segnaposto: nel CSS usa var(--colore-principale) e var(--colore-secondario).',
  'Se l\'ufficio non sceglie i colori del cantiere, quelle due variabili valgono i colori standard di BOP.',
];

export const TAG_AMMESSI = 'div, section, header, footer, main, article, aside, nav, h1-h6, p, span, a, img, picture, source, figure, figcaption, ul, ol, li, strong, em, b, i, small, br, hr, blockquote, table (con thead, tbody, tfoot, tr, th, td, caption)';
export const ATTRIBUTI_AMMESSI = 'class, id, title, alt, width, height, loading, href, src, srcset, sizes, role, aria-*';

export const REGOLE_HTML: string[] = [
  'Il file HTML contiene solo il contenuto della pagina: niente <html>, <head>, <body> e niente <!DOCTYPE>. Al massimo 200 KB.',
  `Tag ammessi: ${TAG_AMMESSI}.`,
  `Attributi ammessi: ${ATTRIBUTI_AMMESSI}.`,
  'Tag vietati: script, iframe, object, embed, form, input, textarea, select, button, link, meta, base, style, frame, frameset. Il CSS va nel file CSS, non in un tag style.',
  'Attributi vietati: tutti quelli che iniziano con "on" (onclick, onload, …) e style. Niente JavaScript, niente stili in linea: usa le classi e il file CSS.',
  'href accetta solo: ancore (#sezione), indirizzi completi https:, mailto: o tel:, oppure un segnaposto scritto così: l\'intero valore dell\'attributo deve essere uno solo tra {{cantiere.brochure}}, {{cantiere.copertina}}, {{impresa.logo}}, {{negozio.logo}}, oppure mailto:{{negozio.email}} o tel:{{negozio.telefono}}. Nessun altro segnaposto, e nessun testo prima o dopo, dentro href. Vietati javascript: e http:.',
  'Ai link esterni BOP aggiunge rel="noopener noreferrer"; target è ammesso solo con valore _blank.',
  'width e height devono essere numeri interi senza unità (width="120", non "120px" né "50%"): per le misure usa il CSS.',
  'I commenti HTML (<!-- … -->) vengono eliminati. "Scarica HTML" restituisce la versione ripulita dal sistema, quindi senza commenti.',
];

export const REGOLE_CSS: string[] = [
  'Il file CSS è un unico file, al massimo 200 KB. Il suo stile vale solo dentro il modello: la pagina è isolata, quindi i selettori body e html non funzionano. Usa classi; per lo sfondo o il carattere di tutta la pagina usa :host { … }.',
  'Vietati: @import, expression(, javascript:, vbscript:, behavior, -moz-binding, </style, image-set(, src(, i segnaposto {{ }} (nel CSS non esistono: per i colori usa le variabili), ::slotted e position: fixed.',
  'url(...) ammesso solo con immagini/<nomefile> oppure data:image/... Niente font o immagini da indirizzi esterni: usa i font di sistema.',
];

export const ISTRUZIONI_INIZIALI: string[] = [
  'Devi produrre due file: modello.html e modello.css (più, se servono, le immagini).',
  'Parti dal modello di esempio fornito insieme a questa guida: è la pagina standard di BOP riscritta come modello e contiene i segnaposto principali.',
  'Rispetta alla lettera i segnaposto e le regole qui sotto: il modello viene controllato al caricamento e rifiutato, con l\'elenco degli errori, se una regola non è rispettata.',
  'Consiglio: gli acquirenti aprono la pagina soprattutto da telefono, quindi prevedi un layout fluido che si legga bene anche sugli schermi stretti.',
];

export const COME_SI_USA: string[] = [
  'Scarica il modello di esempio (HTML e CSS) da questa pagina.',
  'Dai a Claude questa guida, il modello di esempio, il logo o le immagini e una descrizione dello stile voluto (colori, tono, struttura).',
  'Carica i file prodotti con "Nuovo modello": se qualcosa non va, il sistema elenca gli errori da incollare a Claude per la correzione.',
  'Scegli il modello nel riquadro "Aspetto della pagina" dell\'offerta capitolato e controlla l\'anteprima.',
];

// Guida in formato Markdown, per scaricarla e consegnarla a Claude.
export function generaMarkdownGuida(): string {
  const elenco = (voci: string[]) => voci.map(v => `- ${v}`).join('\n');
  const tabella = SEGNAPOSTO_TESTO.map(v => `| \`${v.codice}\` | ${v.significato} |`).join('\n');
  return [
    '# Guida ai segnaposto dei modelli della pagina di prenotazione',
    '',
    '## Istruzioni per chi crea il modello',
    elenco(ISTRUZIONI_INIZIALI),
    '',
    '## Segnaposto di testo',
    'Si scrivono con le doppie graffe, per esempio `{{cantiere.nome}}`. Sono gli unici ammessi.',
    '',
    '| Segnaposto | Contenuto |',
    '| --- | --- |',
    tabella,
    '',
    '## Il blocco di prenotazione: {{prenotazione}}',
    elenco(REGOLE_PRENOTAZIONE),
    '',
    '## Contenuti facoltativi: {{#se}} … {{/se}}',
    elenco(REGOLE_CONDIZIONALE),
    '',
    '## Regole sui segnaposto',
    elenco(REGOLE_TESTO),
    '',
    '## Immagini',
    elenco(REGOLE_IMMAGINI),
    '',
    '## Colori del cantiere',
    elenco(REGOLE_COLORI),
    '',
    '## Regole del file HTML',
    elenco(REGOLE_HTML),
    '',
    '## Regole del file CSS',
    elenco(REGOLE_CSS),
    '',
    '## Come si usa',
    COME_SI_USA.map((v, i) => `${i + 1}. ${v}`).join('\n'),
    '',
  ].join('\n');
}
